module.exports = __webpack_public_path__ + "assets/img/Logo-BBVA.52a7860f.png";